let Index = () => import("../pages/guide/Index");
let GuideLayout = () => import("../components/guide/GuideLayout");
let Guides = () =>  import('../pages/guide/Guides')
let GuideDetails = () =>  import('../pages/guide/GuideDetails')

export default [
    {
        path: "/guide/",
        component: GuideLayout,
        redirect: "/guide/index",
        children: [
            {
                path: "index",
                component: Index,
                name: "GuideIndex",
                meta: { requiresAuth: false },
            },
            {
                path: "/guides",
                component: Guides,
                name: "Guides",
                meta: { requiresAuth: false },
            },
            {
                path: "/guides/category/:categorySlug?",
                component: Guides,
                name: "GuideFilter",
                meta: { requiresAuth: false },
            },
            {
                path: "/guides/search/:searchKeyword?",
                component: Guides,
                name: "SearchGuide",
                meta: { requiresAuth: false },
            },
            {
                path: "/guide-details/:slug",
                component: GuideDetails,
                name: "GuideDetails",
                meta: { requiresAuth: false },
            },
        ],
    },
];
